// extracted by mini-css-extract-plugin
export default {"primary":"#4e342e","primaryLight":"#a1887f","primaryDark":"#211513","bgPrimary":"#111111","bgSecondary":"#212121"};